import { Flex } from 'common/src/designSystem/components/flex';
import {
    AccreditationsFormsCustomFieldInput,
    FormCustomFieldFragment
} from 'common/src/generated/types';
import { noop } from 'lodash-es';
import * as React from 'react';
import { DragDropContext, Droppable, DroppableProvided } from 'react-beautiful-dnd';
import { FormField } from '../../forms/update/elements/formField';

interface IAttachFormCustomFieldsListProps {
    formCustomFields: FormCustomFieldFragment[];
    formCustomFieldsValues: AccreditationsFormsCustomFieldInput[];

    onDelete(index: number): void;
    onDragEnd(params: any): void;
    toggleMandatory(index: number, isMandatory: boolean): void;
}

export const AttachFormCustomFieldsList = (props: IAttachFormCustomFieldsListProps) => {
    const idToCustomField = React.useMemo(
        () => Object.fromEntries(props.formCustomFields.map((cf) => [cf.id, cf])),
        [props.formCustomFields]
    );

    return (
        <DragDropContext onDragEnd={props.onDragEnd}>
            <Droppable droppableId="1">
                {(droppableProvided: DroppableProvided) => (
                    <Flex
                        css={{
                            bd: true
                        }}
                        direction="column"
                        width={1}
                        {...droppableProvided.droppableProps}
                        ref={droppableProvided.innerRef}
                    >
                        {props.formCustomFieldsValues.map((fcfv, index) => (
                            <FormField
                                key={fcfv.id}
                                css={{
                                    border: 'none',
                                    borderBottom: '1px solid $gray200',
                                    borderRadius: '0',
                                    boxShadow: 'none',
                                    '&:last-child': { borderBottom: 'none' }
                                }}
                                elementId={fcfv.id}
                                field={idToCustomField[fcfv.customFieldId!]}
                                index={index}
                                isMandatory={fcfv.isMandatory}
                                showEdit={false}
                                toggleIsMandatory={props.toggleMandatory}
                                updateCustomField={noop}
                                onDelete={props.onDelete}
                            />
                        ))}

                        {droppableProvided.placeholder}
                    </Flex>
                )}
            </Droppable>
        </DragDropContext>
    );
};
